import React, { useState, useEffect } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { Box, Modal } from "@mui/material";
import colors from "assets/theme/base/colors";

const Imagepreview = ({ open, onClose, imageUrl }) => {
  const { sideNav } = colors;
  const [dimensions, setDimensions] = useState({ width: 500, height: 500 });
  const [imageLoaded, setImageLoaded] = useState(false);

  useEffect(() => {
    if (imageUrl && open) {
      setImageLoaded(false);
      const img = new Image();

      img.onload = () => {
        const maxWidth = window.innerWidth * 0.9; // 90% of viewport width
        const maxHeight = window.innerHeight * 0.9; // 90% of viewport height

        let width = img.width;
        let height = img.height;

        // Calculate aspect ratio
        const aspectRatio = width / height;

        // Scale down if image is larger than max dimensions
        if (width > maxWidth) {
          width = maxWidth;
          height = width / aspectRatio;
        }

        if (height > maxHeight) {
          height = maxHeight;
          width = height * aspectRatio;
        }

        // Set minimum dimensions
        const minSize = 300;
        if (width < minSize && height < minSize) {
          if (aspectRatio > 1) {
            width = minSize;
            height = width / aspectRatio;
          } else {
            height = minSize;
            width = height * aspectRatio;
          }
        }

        setDimensions({ width: Math.round(width), height: Math.round(height) });
        setImageLoaded(true);
      };

      img.onerror = () => {
        setDimensions({ width: 500, height: 500 });
        setImageLoaded(true);
      };

      img.src = imageUrl;
    }
  }, [imageUrl, open]);

  return (
    <>
      <Modal
        open={open}
        onClose={onClose}
        aria-labelledby="image-modal-title"
        aria-describedby="image-modal-description"
      >
        <Box
          sx={{
            position: "relative",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: `${dimensions.width}px`,
            height: `${dimensions.height}px`,
            borderRadius: "10px",
            background: "white",
            "&:focus-visible": {
              outline: "none",
            },
          }}
        >
          <CloseIcon
            onClick={onClose}
            sx={{
              position: "absolute",
              top: "-12px",
              right: "-12px",
              background: `${sideNav.backGround}`,
              color: `${sideNav.textColor}`,
              zIndex: 10,
              width: "30px",
              height: "30px",
              padding: "5px",
              borderRadius: "100%",
              cursor: "pointer",
              "&:hover": {
                backgroundColor: `${sideNav?.hoverTextColor}`,
                color: `${sideNav?.backGround}`,
              },
            }}
          />

          <img
            src={imageUrl}
            alt="Selected"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              borderRadius: "10px",
            }}
          />
        </Box>
      </Modal>
    </>
  );
};

export default Imagepreview;
